// extracted by mini-css-extract-plugin
export default {"body":"TabPanel_body__sdRgo","content":"TabPanel_content__y5W91","nav":"TabPanel_nav__+tQVX","TabItemIcon":"TabPanel_TabItemIcon__cTQD8","navTitle":"TabPanel_navTitle__nen1m"};